import { Box, Stack, Text } from '@/ui';
import {
  validationMappingValueSuffixSx,
  validationMappingValuesListSx,
  validationMappingValuesTitleSx,
  validationMissingValueItemSx,
  validationMissingValueTextSx,
} from './ValidationMappingValues.styles';
import type { ReactElement } from 'react';

type ValidationMissingValuesSectionProps = {
  hideTitle?: boolean;
  title: string;
  values: string[];
};

export const ValidationMissingValuesSection = ({
  hideTitle = false,
  title,
  values,
}: ValidationMissingValuesSectionProps): ReactElement | null => {
  if (values.length === 0) return null;

  return (
    <Stack gap="xs">
      {hideTitle ? null : (
        <Text role="body" sx={validationMappingValuesTitleSx}>
          {title}
        </Text>
      )}
      <Box sx={validationMappingValuesListSx}>
        {values.map((value, index) => {
          const suffix = index < values.length - 1 ? ',' : '';
          return (
            <Box
              key={`${title}-${value}-${index}`}
              component="span"
              sx={validationMissingValueItemSx}
            >
              <Text role="body" component="span" sx={validationMissingValueTextSx}>
                {value}
              </Text>
              {suffix ? (
                <Text
                  role="body"
                  component="span"
                  color="textSecondary"
                  sx={validationMappingValueSuffixSx}
                >
                  {suffix}
                </Text>
              ) : null}
            </Box>
          );
        })}
      </Box>
    </Stack>
  );
};
